import { AffiliateReferralService, AffiliateReferralError } from '@/services/affiliate-referral.service'

const state =  {
    loading: false,
    stages: [],
    
    serverResponse: null,
}

const getters = {
    loading: (state) => {
        return state.loading
    },

    stages: (state) => {
        return state.stages
    },

    serverResponse: (state) => {
        return state.serverResponse
    },
}

const actions = {
    async fetchStages({ commit }) {
        commit('startRequest');
        try {
            const response = await AffiliateReferralService.fetchStages();
            commit('fetchStagesSuccess', response)
        } catch (e) {
            if (e instanceof AffiliateReferralError) {
                commit('stopRequest')
            }

            return false
        }
    },
}

const mutations = {
    startRequest(state) {
        state.loading = true;
    },

    fetchStagesSuccess(state, response) {
        state.stages = response.stages
        state.loading = false
    },

    stopRequest(state) {
        state.loading = false
    },
}

export const affiliate = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
